/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

import './disconnect-cloud-licensing-modal.component.less';

import {
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import * as l10n from './disconnect-cloud-licensing-modal.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for disconnecting from Cloud Licensing.
 * @author Shubham Bindal
 */
@Component({
    selector: 'disconnect-cloud-licensing-modal',
    templateUrl: './disconnect-cloud-licensing-modal.component.html',
})
export class DisconnectCloudLicensingModalComponent {
    @Input()
    public headerTitle = '';

    @Output()
    public readonly onClose = new EventEmitter<void>();

    @Output()
    public readonly onConfirm = new EventEmitter<boolean>();

    public readonly l10nKeys = l10nKeys;

    public disconnectFromCloudServices = false;

    public busy = false;

    constructor(private readonly l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    public get header(): string {
        return this.headerTitle || this.l10nService.getMessage(l10nKeys.disconnectFromCloudLicensingHeader);
    }

    /**
     * Handle user clicking -> Cancel.
     */
    public handleCancel(): void {
        this.onClose.emit();
    }

    /**
     * Handle confirm button click.
     */
    public handleConfirm(): void {
        this.onConfirm.emit(this.disconnectFromCloudServices);
    }
}
